import {Typography} from "@mui/material";

export default ({center, children, style}: { children: any, style?: any, center?: boolean,  }) => (
    <Typography variant="h5" fontWeight={600} style={style || (center ? {textAlign: 'center'} : {})}>
        {children}
    </Typography>
)
